module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAARCAMAAAAMs7fIAAAASFBMVEUAAAAre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8uTG0A7AAAAF3RSTlMA+TCQBpE4LAvXlOTUmMq7jirYvUQWFRhNt14AAAB8SURBVBjTZY9ZDsMgDEQ9mMUkJE26zf1v2lqkqgTvA+Qnr+KcRwXqccpFXHixWRc3ImWznMBHdLNwDT05rFy+XwFcdAUUEWXygPQ3UUUq899kVhEweuyIRGIwRkxVbe48Tx833H5XaDALCrK9h0sb955e9A40LfLanzLzAeIEB/VWsnhiAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_amplify_hover.png
// module id = 5L0c
// module chunks = 9